export default "//cdn.scentbird.com/assets/frontbird-site/images/mobile_6e8e2b.jpg";